import {Stack, TextField} from "@mui/material";
import Property from "crqlar-react-common/dist/components/Property";
import React from "react";
import {useTranslation} from "react-i18next";
import {DigitalSigningTemplateForm} from "./digitalSigningTemplate.util";

type LegalLinks = Pick<DigitalSigningTemplateForm, 'privacyPolicyUrl' | 'imprintUrl'>;

interface Props {
    value: LegalLinks
    onChange: (value: LegalLinks) => void
    errors?: {privacyPolicyUrl?: string, imprintUrl?: string}
    disabled?: boolean
}

/** Privacy policy and imprint URL fields for the guest page footer. */
const DigitalSigningLegalFields = ({value, onChange, errors, disabled}: Props) => {
    const {t} = useTranslation();

    const row = (field: keyof LegalLinks, title: string) => {
        const error = errors?.[field];

        return (
            <Property title={title} tooltip={t('Linked in the footer of the guest page. Empty: not shown.')}>
                <TextField
                    fullWidth
                    size={'small'}
                    value={value[field] ?? ''}
                    disabled={disabled}
                    error={!!error}
                    helperText={error && t(error)}
                    inputProps={{'aria-label': title}}
                    onChange={event => onChange({...value, [field]: event.target.value})}
                />
            </Property>
        );
    };

    return (
        <Stack gap={{xs: 1.5, sm: 1}}>
            {row('privacyPolicyUrl', t('Privacy policy'))}
            {row('imprintUrl', t('Imprint'))}
        </Stack>
    );
};

export default DigitalSigningLegalFields;
